import React from 'react';
import styled from 'styled-components';
import PSLoading from './PSLoading';

const FullScreenLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const GlobalSpinner = ({ show }) => {
  if (!show) return null;
  return (
    <FullScreenLoader>
      <PSLoading color="#fff" width={30} height={30} />
    </FullScreenLoader>
  );
};

export default GlobalSpinner;
